import { GET_NEWS_DATA, GET_NEWS_LOAD, GET_NEWS_ERROR } from '../actionTypes';

const INITIAL_STATE = {
  data: {
    data: []
  },
  load: false,
  error: null,
};

export const getNewsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_NEWS_DATA: {
      return {
        ...state,
        data: action.data,
      };
    }
    case GET_NEWS_LOAD: {
      return {
        ...state,
        load: action.load,
      };
    }
    case GET_NEWS_ERROR: {
      return {
        ...state,
        error: action.error,
      }
    }
    default:
      return state;
  }
}